import { render, staticRenderFns } from "./settings-modal.vue?vue&type=template&id=565d679d&"
import script from "./settings-modal.vue?vue&type=script&lang=js&"
export * from "./settings-modal.vue?vue&type=script&lang=js&"
import style0 from "./settings-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "settings-modal.vue"
export default component.exports